import React from 'react';
import { LocaleContext } from './context';
export var LocaleProvider = function (props) {
    var locale = props.locale, children = props.children;
    return React.createElement(LocaleContext.Provider, { value: locale }, children);
};
